export default __webpack_public_path__ + "static/media/web.128da71b.jpg";